import Icon from '../components/Icon.vue'

Icon.register({"hourglass-start":{"width":384,"height":512,"paths":[{"d":"M360 0H24C10.7 0 0 10.7 0 24V40C0 53.3 10.7 64 24 64 24 155 75 231.7 144.8 256 75 280.3 24 357 24 448 10.7 448 0 458.7 0 472V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V472C384 458.7 373.3 448 360 448 360 357 309 280.3 239.2 256 309 231.7 360 155 360 64 373.3 64 384 53.3 384 40V24C384 10.7 373.3 0 360 0zM296 448H88C88 370.5 134.2 304 192 304 249.8 304 296 370.5 296 448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hourglass-start.js
// module id = a5eB
// module chunks = 0